import { createSlice } from "@reduxjs/toolkit";
import axios from "../axios";
import { buildApiV3Url } from "../shared/Utils";

export const customerQuickSearchSlice = createSlice({
    name: "customerQuickSearch",
    initialState: {
        isloading: false,
        data: [],
    },

    reducers: {
        setLoading: (state, action) => {
            state.isloading = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const { setLoading, setData } = customerQuickSearchSlice.actions;

export const selectData = state => {
    return state.customerQuickSearch.data;
};

export const selectIsLoading = state => {
    return state.customerQuickSearch.isloading;
};

/**
 * @param {string} value Raw user input.
 * @param {{ top?: number, includeVendors?: boolean, includeAddress?: boolean }} [options]
 * @returns {Promise<Array>} Type-ahead rows from the API.
 */
export const quickSearch = async (value, options = {}) => {
    const { top, includeVendors = false, includeAddress } = options;

    const params = new URLSearchParams();
    params.append("searchString", (value ?? "").trim());
    if (typeof top === "number") params.append("top", String(top));
    params.append("includeVendors", String(includeVendors));
    if (typeof includeAddress === "boolean") {
        params.append("includeAddress", String(includeAddress));
    }
    const queryString = params.toString().replace(/\+/g, "%20");

    const response = await axios.get(buildApiV3Url(`customers/typeahead?${queryString}`), {
        withCredentials: true,
    });
    return response?.data ?? [];
};

export const clearQuickSearch = () => async dispatch => {
    dispatch(setData([]));
};
export default customerQuickSearchSlice.reducer;
